// src/styles/base/index.ts
/**
 * Theme Orchestrator - assembles all architectural components into a cohesive whole
 */

import { createTheme } from '@mui/material/styles';
import { breakpoints, customExtensions, palette, shape, typography } from './foundations';
import { entityIcons } from '../icons';

import { buttonOverrides } from './components/buttons';
import { dialogOverrides } from './components/dialogs';
import { formOverrides } from './components/forms';
import { navigationOverrides } from './components/navigation';
import { tableOverrides } from './components/tables';
import { gridVariants, typographyVariants } from './components/layout';
import { cardContentOverrides, cardHeaderVariants, cardVariants } from './components/cards';

const theme = createTheme({
    breakpoints,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    palette: palette as any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typography: typography as any,
    shape,

    ...customExtensions,
    entityIcons,

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    components: {
        ...buttonOverrides,
        ...dialogOverrides,
        ...formOverrides,
        ...navigationOverrides,
        ...tableOverrides,
        MuiTypography: typographyVariants,
        MuiCard: cardVariants,
        MuiCardContent: cardContentOverrides,
        MuiCardHeader: cardHeaderVariants,
        MuiGrid: gridVariants,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any,
});

export default theme;
export { entityIcons } from '../icons';
export * from './foundations';
